import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import cardActions from '../../../actions/savedCards';
import cybersourceActions from '../../../actions/cybersource';
import propLoaders from '../../../prop-loaders';
import {
    getAvailableLanguageCodes,
    getCsrf,
    getGenericError,
    getLanguageCode,
    getTranslations
} from '../../../utils/selectors';
import Spinner from '../../atoms/Spinner';
import {CreditCardSection} from '../../organisms';
import {useCybersourceConfirmation} from './cybersource-confirmation.hooks';

export const CybersourceConfirmation = ({
    dispatch,
    actions,
    languageCode,
    translations,
    availableLanguageCodes,
    csrfToken,
    genericError,
    cardDetails: initCardDetails,
    error: initError,
    cyberSourceData,
    match
}) => {
    const paymentSessionId = match.params.sessionId;

    const {
        isSubmitting, onSubmit, cardDetails, isCardinalLoading
    } = useCybersourceConfirmation({
        languageCode,
        paymentSessionId,
        availableLanguageCodes,
        csrfToken,
        dispatch,
        actions,
        initError,
        initCardDetails,
        cyberSourceData
    });

    if (!cardDetails || isCardinalLoading) {
        return <Spinner styles={{minHeight: 300, height: 'auto'}} />;
    }

    return (
        <CreditCardSection
            showCancelButton
            isSubmitting={isSubmitting}
            genericError={genericError}
            translations={translations}
            maskedCardNumber={cardDetails?.maskedCardNumber}
            onSubmit={onSubmit}
            languageCode={languageCode}
        />
    );
};


CybersourceConfirmation.getServerSideProps = async (context, store) => {
    try {
        const {
            languageCode, requestId, sessionId, params: {sessionId: paymentSessionId}
        } = context;
        const cardDetails = await propLoaders.getCybersourceCardDetails(
            {
                languageCode, requestId, sessionId, query: {paymentSessionId}
            }
        );

        await cybersourceActions.loadCyberSourceInit({
            languageCode, requestId, sessionId, query: {paymentSessionId}
        })(store.dispatch);

        return {cardDetails};
    } catch (error) {
        store.dispatch(genericErrorHasOccurred(true));
        return {
            cardDetails: null,
            error
        };
    }
};

CybersourceConfirmation.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            sessionId: PropTypes.string.isRequired
        }).isRequired
    }).isRequired,
    translations: PropTypes.shape().isRequired,
    csrfToken: PropTypes.string.isRequired,
    availableLanguageCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    genericError: PropTypes.bool,
    error: PropTypes.shape(),
    cardDetails: PropTypes.shape({
        maskedCardNumber: PropTypes.string.isRequired,
        expirationDate: PropTypes.string.isRequired,
        cardType: PropTypes.string.isRequired
    }),
    cyberSourceData: PropTypes.shape({
        cardinalToken: PropTypes.string,
        cancellationUrl: PropTypes.string,
        captureContext: PropTypes.string
    })
};

CybersourceConfirmation.defaultProps = {
    genericError: null,
    cardDetails: null,
    cyberSourceData: null,
    error: null
};

const mapStateToProps = state => ({
    genericError: getGenericError(state),
    translations: getTranslations(state),
    languageCode: getLanguageCode(state),
    csrfToken: getCsrf(state),
    availableLanguageCodes: getAvailableLanguageCodes(state),
    cyberSourceData: state.cyberSourceData
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({...cardActions, ...cybersourceActions}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CybersourceConfirmation);
